import React, { useContext, useState, useEffect } from "react";
import { WorkContext } from "./WorkContext";
import { throttle } from "lodash";
import { navigate } from "../../utils";
import { styled, media } from "../../styles";
import { Page, Content, TitleImage } from "../../components";
import { ProjectFilter, ProjectGrid } from "./components";
import workImg from "./assets/Illu_Work.svg";

export interface WorkPageProps {
  ["*"]: string;
}

export const WorkPage: React.FC<WorkPageProps> = props => {
  const { state, dispatch } = useContext(WorkContext);
  const [reachedEnd, setReachedEnd] = useState(false);

  const scrollHandler = (evt: any) => {
    const pathname =
      typeof window !== "undefined" &&
      window.location &&
      window.location.pathname
        ? window.location.pathname
        : "/work/";

    let currScrollPos =
      evt.target.body.scrollTop || evt.target.documentElement.scrollTop;

    if (!pathname.includes("project")) {
      let itemsCount = document.getElementsByTagName("ul")[1].children.length;
      dispatch({
        type: "SET_SCROLL_POS",
        meta: { items: itemsCount, position: currScrollPos }
      });
    }
  };

  useEffect(() => {
    if (state.scrollMeta.position) {
      document.documentElement.scrollTop = state.scrollMeta.position;
    }
    document.addEventListener("scroll", throttle(scrollHandler, 500));
    console.log(state);
    return () => {
      document.removeEventListener("scroll", scrollHandler);
    };
  }, []);

  useEffect(() => {
    console.log(state);
  }, [state]);

  if (state.initialized) {
    const pathname =
      typeof window !== "undefined" &&
      window.location &&
      window.location.pathname
        ? window.location.pathname
        : "/work/";

    let selectedCategory: string =
      pathname
        .split("/")
        .filter(
          part =>
            part.trim() !== "" && part.trim() !== "en" && part.trim() !== "work"
        )[0] || "";

    if (!selectedCategory || selectedCategory === "work") {
      selectedCategory = state.categories.find(cat => cat.slug === "recent")
        ? "recent"
        : "";
    }

    if (state.selectedCategory !== selectedCategory) {
      // console.log("selected cat", selectedCategory);
      if (
        selectedCategory &&
        state.categories.length > 0 &&
        !state.categories.find(cat => selectedCategory === cat.slug)
      ) {
        navigate("/work/");
        return null;
      }

      setTimeout(() => {
        dispatch({
          type: "TOGGLE_SEARCH",
          searchOpen: selectedCategory === ""
        });

        if (!state.searchTerm) {
          dispatch({
            type: "SET_CATEGORY",
            selectedCategory
          });
        }
      }, 0);
    }
  }

  const onChange = (event: React.FormEvent<HTMLInputElement>) => {
    const nextTerm =
      typeof event.currentTarget.value === "string"
        ? event.currentTarget.value
        : state.searchTerm;

    dispatch({ type: "SET_SEARCHTERM", searchTerm: nextTerm });
  };

  const toggleSearch = () => {
    dispatch({ type: "TOGGLE_SEARCH" });
  };

  return (
    <Page
      title="Work"
      description="Guckt euch das an: unsere Projects für die ganz Großen. Und die lieben Kleinen – u.a. Composition, Music Recording, Film & Audiobooks."
      seoTitle="Work | Sound Design, Commercials, Film & Audiobooks | German Wahnsinn"
      headerSkull="Work"
      sideLabel={true}
      footer={reachedEnd}
      mobileHeaderFixed={false}
      {...props}
    >
      <Content>
        <WorkTitleImage title="Work" src={workImg} />
      </Content>

      {state.initialized ? (
        <>
          <ProjectFilter
            categories={state.categories}
            selectedCategory={state.selectedCategory}
            searchTerm={state.searchTerm}
            onChange={onChange}
            searchOpen={state.searchOpen}
            toggleSearch={toggleSearch}
          />

          <ProjectGrid
            projects={state.filteredProjects}
            selectedCategory={state.selectedCategory}
            searchTerm={state.searchTerm}
            setReachedEnd={setReachedEnd}
            itemCount={state.scrollMeta.items}
          />
        </>
      ) : null}
    </Page>
  );
};

const WorkTitleImage = styled(TitleImage as any)`
  ${media.landscape} {
    width: 50%;

    img {
      width: 100%;
    }
  }

  ${media.tablet} {
    width: 50%;
    margin-top: 5%;

    img {
      width: 100%;
    }
  }

  ${media.laptop} {
    width: 45%;
    margin-top: 1%;

    img {
      width: 100%;
    }
  }
`;
